/* Wishlist (2026-10-05, owner). Any element with data-wish="<product handle>" is a heart: a click adds or removes it.
   The wishlist belongs to the customer's account (owner: signed out, a heart asks them to sign in first). Signed in
   (window.VDH_WISH.me, signed in layout/theme.liquid) it lives on the reviews worker (/api/wish), so it follows them
   to any device. The heart tapped before signing in is saved once they're back, as is any list an older version of
   this script kept in the browser. data-wish-count elements show how many are saved.
   The same pop-up guards "Write a review" links (data-review-ask): signed out, it asks them to sign in and brings them
   back to that link (the review page, on the product they want to rate). */
(function(){
  var C = window.VDH_WISH || {}, GUEST = 'vdh_wishlist', ACCT = 'vdh_wishlist_acct', PENDING = 'vdh_wish_pending', me = C.me;
  function read(k){ try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch(e){ return null; } }
  function write(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }
  function drop(k){ try { localStorage.removeItem(k); } catch(e){} }
  var cached = me ? read(ACCT) : null;
  var list = me && cached && cached.e === me.e && cached.items ? cached.items : [];
  var subs = [];
  function keep(){ if(me) write(ACCT, { e: me.e, items: list }); }
  function hearts(){                             // every heart and counter on the page shows the current list
    Array.prototype.forEach.call(document.querySelectorAll('[data-wish]'), function(el){
      var on = list.indexOf(el.getAttribute('data-wish')) > -1, label = el.getAttribute(on ? 'data-label-on' : 'data-label-off');
      el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if(label) el.setAttribute('aria-label', label);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-wish-count]'), function(el){ el.textContent = list.length; el.hidden = !list.length; });
  }
  function paint(){ hearts(); subs.forEach(function(f){ f(list.slice()); }); }
  function server(add, remove){                  // resolves true once the account's list is back
    if(!me || !C.api) return Promise.resolve(false);
    var f = new FormData(); f.append('e', me.e); f.append('ts', me.ts); f.append('sig', me.sig);
    if(add) f.append('add', add); if(remove) f.append('remove', remove);
    return fetch(C.api + '/api/wish', { method: 'POST', body: f }).then(function(r){ return r.json(); }).then(function(d){
      if(!d || !d.items) return false;
      list = d.items; keep(); paint(); return true;
    }).catch(function(){ return false; });
  }
  var note, noteT;                               // a short "Saved / Removed" note at the bottom (not on the wishlist page)
  function toast(added){
    if(/^\/pages\/wishlist/.test(location.pathname)) return;
    if(!note){ note = document.createElement('div'); note.className = 'vdh-toast'; note.setAttribute('role', 'status'); document.body.appendChild(note); }
    note.innerHTML = added ? '<span>&hearts; Saved to your wishlist</span><a href="/pages/wishlist">View</a>' : '<span>Removed from your wishlist</span>';
    void note.offsetWidth; note.classList.add('is-on');
    clearTimeout(noteT); noteT = setTimeout(function(){ note.classList.remove('is-on'); }, 2600);
  }
  function loginUrl(){ return '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search); }
  var ask, back;                                 // signed out: a pop-up asking them to sign in first
  function close(){ if(ask && !ask.hidden){ ask.hidden = true; if(back) back.focus(); } }
  function openAsk(o){                           // o: title, text, returnTo (path), onGo, from
    if(!ask){
      ask = document.createElement('div'); ask.className = 'vdh-ask'; ask.hidden = true;
      ask.innerHTML = '<div class="vdh-ask-bg" data-close></div><div class="vdh-ask-box" role="dialog" aria-modal="true" aria-labelledby="VdhAskH">' +
        '<button type="button" class="vdh-ask-x" data-close aria-label="Close">&times;</button><h2 id="VdhAskH"></h2><p></p>' +
        '<a class="btn btn--red vdh-ask-go" href="#">Sign in</a><button type="button" class="vdh-ask-no" data-close>Not now</button></div>';
      document.body.appendChild(ask);
      ask.addEventListener('click', function(e){ if(e.target.closest('[data-close]')) close(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    }
    ask.querySelector('h2').textContent = o.title; ask.querySelector('p').textContent = o.text;
    var go = ask.querySelector('.vdh-ask-go');
    go.href = '/customer_authentication/login?return_to=' + encodeURIComponent(o.returnTo || location.pathname + location.search);
    go.onclick = o.onGo || null;
    back = o.from; ask.hidden = false; go.focus();
  }
  function askSignIn(h, from){
    openAsk({ title: 'Save to your wishlist', from: from, onGo: function(){ write(PENDING, h); },
      text: 'Sign in and it\'s saved to your account, on any phone or computer. No password needed: we email you a 6-digit code.' });
  }
  function toggle(h, from){
    if(!me){ askSignIn(h, from); return; }
    var i = list.indexOf(h);
    if(i > -1){ list.splice(i, 1); keep(); paint(); server('', h); toast(false); }
    else { list.unshift(h); keep(); paint(); server(h, ''); toast(true); }
  }
  function hit(e){ return e.target && e.target.closest ? e.target.closest('[data-wish]') : null; }
  // capture phase: a heart inside a product card's link must not open the product
  document.addEventListener('click', function(e){ var el = hit(e); if(!el) return; e.preventDefault(); e.stopPropagation(); toggle(el.getAttribute('data-wish'), el); }, true);
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var el = hit(e); if(!el || el.tagName === 'BUTTON') return;
    e.preventDefault(); e.stopPropagation(); toggle(el.getAttribute('data-wish'), el);
  }, true);
  document.addEventListener('click', function(e){         // "Write a review": signed in, the link just opens
    var a = e.target && e.target.closest ? e.target.closest('[data-review-ask]') : null; if(!a || me) return;
    e.preventDefault();
    openAsk({ title: 'Write a review', from: a, returnTo: a.getAttribute('href'),
      text: 'Sign in with the email you used at checkout and we\'ll take you straight to the item to rate it. No password needed: we email you a 6-digit code.' });
  });
  window.VDHWish = { signedIn: !!me, loginUrl: loginUrl, items: function(){ return list.slice(); }, toggle: toggle, refresh: hearts,
                     on: function(f){ subs.push(f); f(list.slice()); } };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  if(me){                                        // back from signing in: save the heart they tapped (and any older browser list)
    var add = read(GUEST) || [], pend = read(PENDING);
    if(typeof pend === 'string' && add.indexOf(pend) < 0) add.unshift(pend);
    server(add.join(','), '').then(function(ok){ if(!ok) return; drop(GUEST); drop(PENDING); if(pend) toast(true); });
  }
})();
